var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full md:w-5/6"},[_c('div',{staticClass:"overflow-scroll overflow-x-hidden h-80 md:h-56 pb-32 md:pb-18 relative"},_vm._l((_vm.pages),function(page){return _c('Tag',{key:page.id,attrs:{"page":page},on:{"change-page":_vm.changePage}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }